// VERSION 2.2 - FINAL WORKFLOW FIX #4
// =============================================================================
//  SCREEN: BracketManagerScreen (Mit Reset-Funktion)
// =============================================================================
import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import apiClient from '../api';
import { toast } from 'react-toastify';
import { CLASSIFICATIONS } from '../constants/classificationConstants';
import { GAME_MODES } from '../constants/gameModeConstants';

const BracketManagerScreen = () => {
    const { id: tournamentId, gameMode } = useParams();
    const navigate = useNavigate();

    const [koPhaseStatus, setKoPhaseStatus] = useState({});
    const [loading, setLoading] = useState(true);
    const [tournament, setTournament] = useState(null);

    const getLabel = (key, constantList) => constantList.find(c => c.key === key)?.label || key;

    const checkKOPhaseStatus = async () => {
        try {
            setLoading(true);
            const [tournamentRes, scoresRes] = await Promise.all([
                apiClient.get(`/api/tournaments/${tournamentId}`),
                apiClient.get(`/api/tournaments/${tournamentId}/scores?gameMode=${gameMode}&phase=ko`)
            ]);
            
            setTournament(tournamentRes.data);

            const status = {};
            const classificationsInTournament = tournamentRes.data.classifications.concat(tournamentRes.data.teamClassifications);

            classificationsInTournament.forEach(cls => {
                const hasKOEntry = scoresRes.data.some(score => score.entry?.classification === cls);
                status[cls] = hasKOEntry;
            });
            setKoPhaseStatus(status);
        } catch (err) {
            toast.error("Fehler beim Prüfen des KO-Phasen-Status.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkKOPhaseStatus();
    }, [tournamentId, gameMode]);

    const handleGenerateBracket = async (classification) => {
        if (!tournament) return;
        const koConfig = tournament.koConfiguration.find(c => c.gameMode === gameMode);
        const bracketSize = koConfig ? koConfig.bracketSize : 16;
        if (!window.confirm(`Soll für die Top ${bracketSize} dieser Wertung eine KO-Phase aus den Qualifikationsergebnissen generiert werden?`)) return;

       try {
        // KORRIGIERT: Der API-Pfad wurde an die neue, saubere Route angepasst.
        const { data } = await apiClient.post(`/api/bracket/${tournamentId}/${gameMode}/${classification}`, { bracketSize });
        toast.success(data.message);
        navigate(`/turnier/${tournamentId}/bracket/${gameMode}/${classification}`);
    } catch (err) {
        toast.error(err.response?.data?.message || "Fehler bei der Generierung.");
        }
    };
    
    // NEU: Funktion zum Aufrufen der Reset-API
    const handleResetBracket = async (classification) => {
        if (!window.confirm(`Möchten Sie die generierte KO-Phase für diese Wertung wirklich zurücksetzen? Alle eingegebenen Duell-Ergebnisse gehen verloren.`)) return;
        
        try {
        // KORRIGIERT: Der API-Pfad wurde an die neue, saubere Route angepasst.
        const { data } = await apiClient.delete(`/api/bracket/${tournamentId}/${gameMode}/${classification}`);
        toast.success(data.message);
        checkKOPhaseStatus();
    } catch (err) {
            toast.error(err.response?.data?.message || "Fehler beim Zurücksetzen.");
        }
    };

    if (loading || !tournament) return <p>Prüfe KO-Phasen-Status...</p>;

    const relevantClassifications = tournament.classifications.concat(tournament.teamClassifications);

    return (
        <div className="screen-container">
            <div className="navigation-header">
                <Link to={`/turnier/${tournamentId}/ergebnisse`} className="btn-back">← Zurück zur Ergebnisübersicht</Link>
            </div>
            <h2>KO-Phasen-Manager für: {getLabel(gameMode, GAME_MODES)}</h2>
            <p>Hier können Sie für jede Wertung die KO-Phase aus den Ergebnissen der Qualifikation erstellen oder den bestehenden Turnierbaum einsehen.</p>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Wertung</th>
                            <th>Status</th>
                            <th style={{width: '350px'}}>Aktion</th>
                        </tr>
                    </thead>
                    <tbody>
                        {relevantClassifications.map(cls => (
                            <tr key={cls}>
                                <td>{getLabel(cls, CLASSIFICATIONS)}</td>
                                <td>
                                    {koPhaseStatus[cls] 
                                        ? <span style={{color: 'green', fontWeight: 'bold'}}>Generiert</span> 
                                        : <span>Nicht generiert</span>
                                    }
                                </td>
                                <td>
                                    {koPhaseStatus[cls] ? (
                                        <>
                                            <Link to={`/turnier/${tournamentId}/bracket/${gameMode}/${cls}`} className="btn-edit">Turnierbaum anzeigen</Link>
                                            {/* NEU: Button zum Zurücksetzen */}
                                            <button onClick={() => handleResetBracket(cls)} className="btn-delete" style={{marginLeft: '1rem'}}>Zurücksetzen</button>
                                        </>
                                    ) : (
                                        <button onClick={() => handleGenerateBracket(cls)} className="btn-primary-action">KO-Phase erstellen</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BracketManagerScreen;